export default "__VITE_ASSET__DpQIi3mi__"